<template>
    <div>
        <vs-popup
                class="after-modal"
                :title="title"
                :active.sync="showPopup"
                v-if="hour !== null"
        >
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input
                            class="w-full"
                            label="Start tijd"
                            :value="hour.clocked_in_time"
                            v-model="hour.clocked_in_time"
                    />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input
                            class="w-full"
                            label="Eind tijd"
                            :value="hour.clocked_out_time"
                            v-model="hour.clocked_out_time"
                    />
                </div>
            </div>
            <div class="vs-row ">
                <div class="vx-col sm:w-1/2 mb-2">
                    <vs-button class="mvs-con-loading__container" style="text-align: right" @click="saveHour"
                    >Opslaan
                    </vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        name: "ht-hour-popup",
        data() {
            return {
                showPopup: false,
                hour: null
            };
        },
        computed: {
            title() {
                if (this.hour) {
                    return "Bewerk uur registratie #" + this.hour.id;
                }
            }
        },
        methods: {
            saveHour() {
                let data = new FormData();
                data.append('_method', 'PUT');
                data.append('hour_id', this.hour.id);
                data.append('clocked_in_time', this.hour.clocked_in_time);
                data.append('clocked_out_time', this.hour.clocked_out_time);
                data.append('deliverer_id', this.hour.deliverer_id);
                this.$http
                    .post("v1/deliverer/hour/edit", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showPopup = false;
                        this.$util.notify('Gelukt', 'Registratie is aangepast', this.$vs);
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            }
        },

        mounted() {
            this.$events.listen('open-deliverer-hour', (hour) => {
                this.hour = hour;
                this.showPopup = true;
            });
        }
    };
</script>